import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AnyObject, ErrorMessage } from '@mri/types';
import { toDateTimeFormat } from '@mri/functions';

@Component({
  selector: 'app-field-date-time',
  templateUrl: './field-date-time.component.html',
  styleUrl: './field-date-time.component.scss'
})
export class FieldDateTimeComponent {
  private _classSet: Set<string> = new Set<string>();
  private _value: Date;

  @Output() valueChange = new EventEmitter<string>;
  @Input() placeholder?: string;
  @Input() set value (value: Date | string | number){
    if(this._isEqualDateValue(value)) return;

    this._value = new Date(value);
  }
  @Input() label: string;
  @Input() errors?: Array<ErrorMessage>;
  @Input() image?: string | ((value: string) => string);

  get value(): string {
    const value = this._value;
    if(!value) return '';

    return toDateTimeFormat(value)
  }

  get classes(): string {
    return [...this._classSet].join(' ');
  }

  onChange(event: AnyObject){
    console.log('onChange', new Date(event.target.value).toJSON());

    this.valueChange.emit(new Date(event.target.value).toJSON())
  }

  onFocus(event: AnyObject){
    event.target.showPicker();
    console.log('onFocus');
    this._classSet.add('card-focus');
  }

  onBlur(){
    this._classSet.delete('card-focus');
  }

  private _isEqualDateValue(value: string | number| Date): boolean {
    const currentValue = this._value;

    if(!currentValue) return false;

    const newValue = new Date(value);
    return currentValue.getTime() === newValue.getTime();
  }
}
